<template>
	<div id="contact-area" class="white w-90 center mt3">
		<form v-if="!submitted" id="contact_form">
			<div class="name">
				<label for="name"></label>
				<input v-model="name" type="text" placeholder="My name is" name="name" id="name_input" required>
			</div>
			<div class="email">
				<label for="email"></label>
				<input v-model="email" type="email" placeholder="My e-mail is" name="email" id="email_input" required>
			</div>
			<div class="telephone">
				<label for="name"></label>
				<input v-model="phone" type="text" placeholder="My number is" name="telephone" id="telephone_input" required>
			</div>
			<div class="message">
				<label for="message"></label>
				<textarea v-model="message" name="message" placeholder="I'd like to chat about" id="message_input" cols="30" rows="5" required></textarea>
			</div>
			<div @click="submit" class="submit">
				<input type="submit" value="Send Message" id="form_button" />
			</div>
		</form>
    <div v-if="submitted" class="w-100 center mt3 f3 fw3">
      Thank you for reaching out, I'll be in touch soon!
    </div>
  </div>
</template>

<script>
export default {
	name: 'ContactForm',
	data() {
		return {
      submitted: false,
      name: '',   
      phone: '',
      email:'',   
      message:'', 
    }
  },
  methods: { 
   submit: function() {
    if (this.name && this.phone && this.email && this.message) {
      let data = {
        'name': this.name,
        'phone': this.phone,
        'email': this.email,
        'message': this.message,
        '_subject': "HaymanLLC Contact Form Submission!"
      }
      console.log('SUBMIT', data)
      $.ajax({
        url: "https://formspree.io/danielle@haymanllc.com", 
        method: "POST",
        data: data,
        dataType: "json"
      });
      this.submitted = true;
      event.preventDefault();
    }
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  overflow: visible;
}

button, select {
  text-transform: none;
}

button, input, select, textarea {
  color: #5A5A5A;
  font: inherit;
  margin: 0;
}

input {
  line-height: normal;
}

textarea {
  overflow: auto;
}

h1 {
  color: #474544;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 7px;
  text-align: center;
  text-transform: uppercase;
}

.underline {
  border-bottom: solid 2px white;
  margin: -0.512em auto;
  width: 80px;
}

.icon_wrapper {
  margin: 50px auto 0;
  width: 100%;
}

.icon {
  display: block;
  fill: #474544;
  height: 50px;
  margin: 0 auto;
  width: 50px;
}

.email {
 float: right;
 width: 45%;
}

input[type='text'], [type='email'], select, textarea {
 background: none;
 border: none;
 border-bottom: solid 2px white;
 color: #FFFFFF;
 font-size: 1.000em;
 font-weight: 400;
 letter-spacing: 1px;
 margin: 0em 0 1.875em 0;
 padding: 0 0 0.875em 0;
 text-transform: uppercase;
 width: 100%;
 -webkit-box-sizing: border-box;
 -moz-box-sizing: border-box;
 -ms-box-sizing: border-box;
 -o-box-sizing: border-box;
 box-sizing: border-box;
 -webkit-transition: all 0.3s;
 -moz-transition: all 0.3s;
 -ms-transition: all 0.3s;
 -o-transition: all 0.3s;
 transition: all 0.3s;
}

input[type='text']:focus, [type='email']:focus, textarea:focus {
 outline: none;
 padding: 0 0 0.875em 0;
}

.message {
 float: none;
}

.name {
 float: left;
 width: 45%;
}

select {
  background: url('https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-arrow-down-32.png') no-repeat right;
  color: #ffffff;
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}

select::-ms-expand {
  display: none;
}

.subject {
  width: 100%;
}

.telephone {
  width: 100%;
}

textarea {
	line-height: 150%;
	height: 100px;
	resize: none;
 width: 100%;
}

::-webkit-input-placeholder {
	color: #999999;
}

:-moz-placeholder { 
	color: #999999;
	opacity: 1;
}

::-moz-placeholder {
	color: #999999;
	opacity: 1;
}

:-ms-input-placeholder {
	color: #999999;
}

#form_button {
  background: none;
  border: solid 2px #FFFFFF;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: 'Helvetica', Arial, sans-serif;
  font-size: 0.875em;
  font-weight: bold;
  outline: none;
  padding: 20px 35px;
  text-transform: uppercase;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

#form_button:hover {
  background: #FFFFFF;
  color: #323d49;
}

@media screen and (max-width: 768px) {
  #container {
    margin: 20px auto;
    width: 95%;
  }
}

@media screen and (max-width: 480px) {
  h1 {
    font-size: 26px;
  }
  
  .underline {
    width: 68px;
  }
  
  #form_button {
    padding: 15px 25px;
  }
}

@media screen and (max-width: 420px) {
  h1 {
    font-size: 18px;
  }
  
  .icon {
    height: 35px;
    width: 35px;
  }
  
  .underline {
    width: 53px;
  }
  
  input[type='text'], [type='email'], select, textarea {
    font-size: 0.875em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue